import { CarrierAccount } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as z from "zod";

export const renameCarrierAccount = {
  name: "renameCarrierAccount" as const,
  input: z.object({
    /** The account's `_id`, not its `carrierAccountId`. */
    carrierAccountObjectId: z.string(),
    name: z.string(),
  }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
